import { Routes, Route } from "react-router-dom";
import ContestantView from "./ContestantView";
import HostView from "./HostView";

import "./App.css";

function App() {
  return (
    <Routes>
    <Route path="/">
      {/* <Route index element={<ContestantView />} /> */}
      <Route path="mr-green" element={<ContestantView player={1} />} />
      <Route path="mr-pink" element={<ContestantView player={2} />} />
      <Route path="host" element={<HostView />} />
    </Route>
  </Routes>
  );
}

export default App;
